import app from './app';
import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('./views/Home')
    },
    {
        path: '/contacts',
        name: 'contact',
        component: () => import('./views/Contact')
    },
    {
        path: '/faqs',
        name: 'faqs',
        component: () => import('./views/Faqs')
    },
    {
        path: '/cart',
        name: 'cart',
        component: () => import('./views/Cart')
    },
    {
        path: '/auth',
        name: 'auth',
        meta: {auth: false},
        component: () => import('./views/Auth')
    },
    {
        path: '/reserved/*',
        component: () => import('./components/ReservedLayout'),
        meta: {auth: true},
        children: [
            {
                path: '/reserved',
                redirect: {name: 'reserved.dashboard'}
            },
            {
                path: '/reserved/dashboard',
                name: 'reserved.dashboard',
                component: () => import('./views/reserved/Dashboard')
            },
            {
                path: '/reserved/user/profile',
                name: 'user.profile',
                component: () => import('./views/reserved/UserProfile')
            },
            {
                path: '/reserved/sale/history',
                name: 'sale.history',
                component: () => import('./views/reserved/SaleHistory')
            },
        ]
    },
    {
        path: '/admin/*',
        component: () => import('./components/AdminLayout'),
        meta: {
            auth: {
                roles: ['superadmin', 'admin'],
                forbiddenRedirect: {name: 'forbidden'}
            }
        },
        children: [
            {
                path: '/admin',
                redirect: {name: 'admin.dashboard'}
            },
            {
                path: '/admin/dashboard',
                name: 'admin.dashboard',
                component: () => import('./views/admin/Dashboard')
            },
            {
                path: '/admin/products',
                name: 'admin.products',
                component: () => import('./views/admin/Products')
            },
            {
                path: '/admin/products/edit/:product',
                name: 'admin.product.edit',
                component: () => import('./views/admin/ProductEdit')
            },
            {
                path: '/admin/categories',
                name: 'admin.categories',
                component: () => import('./views/admin/Categories')
            },
            {
                path: '/admin/sales',
                name: 'admin.sales',
                component: () => import('./views/admin/Sales')
            },
            {
                path: '/admin/banners',
                name: 'admin.banners',
                component: () => import('./views/admin/Banners')
            },
            {
                path: '/admin/highlights',
                name: 'admin.highlights',
                component: () => import('./views/admin/Destaques')
            },
        ]
    },
    {
        path: '/store/*',
        component: () => import('./components/ProductsLayout'),
        children: [
            {
                path: '/store/:category?',
                name: 'category.view',
                component: () => import('./views/Products')
            },
            {
                path: '/store/:category/product/:id',
                name: 'product.view',
                component: () => import('./views/Product')
            },
        ]
    },
    {
        path: '/login',
        name: 'login',
        redirect: {name: 'auth'},
    },
    {
        path: '/register',
        name: 'register',
        redirect: {name: 'auth'},
    },
    {
        path: '/403',
        name: 'forbidden',
        component: () => import('./views/errors/Forbidden')
    },
    {
        path: '/404',
        name: 'error.notfound',
        component: () => import('./views/errors/NotFound')
    },
    {
        path: '/500',
        name: 'error.ServerError',
        component: () => import('./views/errors/ServerError')
    },
    {
        path: '*',
        redirect: {name: 'error.notfound'}
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    if (to.path !== from.path) {
        NProgress.start();
        NProgress.set(0.1);
    }
    let toWithQuery;
    //keep these queries
    //if (from.query.como && !to.query.como) {
    //    toWithQuery = Object.assign({}, to, {
    //        query: {
    //            como: from.query.como
    //        }
    //    });
    //}
    next(toWithQuery || undefined);
});

router.afterEach((to, from) => {
    setTimeout(() => NProgress.done(), 100);
    let $auth = Vue.prototype.$auth;
    // force user update
    if (
        to.name !== 'user.profile'
        && $auth.check()
        && (
            $auth.user().password_force_change
            || $auth.user().email_force_change
        )
    ) {
        router.push({name: 'user.profile'});
        alert('Por favor Atualize as suas informações antes de continuar.')
    }
    // scroll to hash
    if (to.hash && to.hash.length) {
        setTimeout(() => {
            let offset = 0;
            app.$scrollTo(to.hash, undefined, {offset: -(offset)})
        }, 500);
    }
    // scroll to top
    else {
        setTimeout(() => app.$scrollTo({top: 0}), 500);
    }
});

export default router;
